import {
  faAngleLeft,
  faAngleRight,
  faArrowDown,
  faArrowLeft,
  faBars,
  faBell,
  faBinoculars,
  faBuilding,
  faCaretDown,
  faCheck,
  faCheckCircle,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faCog,
  faCreditCard,
  faEdit,
  faEnvelope,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFileAlt,
  faFileImport,
  faFolderOpen,
  faInfoCircle,
  faLock,
  faPaperclip,
  faMobile,
  faMobileAlt,
  faMoneyCheck,
  faPhone,
  faPlus,
  faRedoAlt,
  faSearch,
  faSignOutAlt,
  faSpinner,
  faTasks,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faTrash,
  faUnlock,
  faUpload,
  faUser,
  faUserFriends,
  faUserTie,
  faWallet,
  faFileImage,
  faEllipsisH,
  faDownload
} from '@fortawesome/free-solid-svg-icons';
import {
  faCalendarAlt,
  faFrown,
  faSmile,
  faTrashAlt as faTrashAltRegular,
  faFileImage as fafileImageRegular
} from '@fortawesome/free-regular-svg-icons';
import {
  faCcMastercard,
  faCcVisa,
  faGoogle
} from '@fortawesome/free-brands-svg-icons';

// Todo: Backwards compatibility: Remove payment icon assets to Icon components (https://app.clickup.com/t/3870286/ENG-11582)
import { ReactComponent as IconBpi } from '@assets/svg-icons/icon-bpi-light.svg';
import { ReactComponent as IconCreditCards } from '@assets/svg-icons/icon-credit-cards.svg';
import { ReactComponent as IconGcash } from '@assets/svg-icons/icon-gcash.svg';
import { ReactComponent as IconGooglePay } from '@assets/svg-icons/icon-google-pay.svg';
import { ReactComponent as IconGrabpay } from '@assets/svg-icons/icon-grabpay-light.svg';
import { ReactComponent as IconMastercard } from '@assets/svg-icons/icon-mastercard.svg';
import { ReactComponent as IconOtc } from '@assets/svg-icons/icon-otc.svg';
import { ReactComponent as IconPaymaya } from '@assets/svg-icons/.deprecated/icon-paymaya.svg';
import { ReactComponent as IconShopeePay } from '@assets/svg-icons/icon-shopeepay.svg';
import { ReactComponent as IconVisa } from '@assets/svg-icons/icon-visa.svg';

export default {
  angleLeft: {
    asset: faAngleLeft,
    type: 'fa'
  },
  angleRight: {
    asset: faAngleRight,
    type: 'fa'
  },
  arrowDown: {
    asset: faArrowDown,
    type: 'fa'
  },
  arrowLeft: {
    asset: faArrowLeft,
    type: 'fa'
  },
  bell: {
    asset: faBell,
    type: 'fa'
  },
  binoculars: {
    asset: faBinoculars,
    type: 'fa'
  },
  bpi: {
    asset: IconBpi,
    type: 'assets'
  },
  building: {
    asset: faBuilding,
    type: 'fa'
  },
  calendar: {
    asset: faCalendarAlt,
    type: 'fa'
  },
  caretDown: {
    asset: faCaretDown,
    type: 'fa'
  },
  ccMastercard: {
    asset: faCcMastercard,
    type: 'fa'
  },
  ccVisa: {
    asset: faCcVisa,
    type: 'fa'
  },
  check: {
    asset: faCheck,
    type: 'fa'
  },
  checkCircle: {
    asset: faCheckCircle,
    type: 'fa'
  },
  chevronLeft: {
    asset: faChevronLeft,
    type: 'fa'
  },
  chevronRight: {
    asset: faChevronRight,
    type: 'fa'
  },
  circle: {
    asset: faCircle,
    type: 'fa'
  },
  cog: {
    asset: faCog,
    type: 'fa'
  },
  creditCard: {
    asset: faCreditCard,
    type: 'fa'
  },
  download: {
    asset: faDownload,
    type: 'fa'
  },
  edit: {
    asset: faEdit,
    type: 'fa'
  },
  ellipsisH: {
    asset: faEllipsisH,
    type: 'fa'
  },
  envelope: {
    asset: faEnvelope,
    type: 'fa'
  },
  externalLinkAlt: {
    asset: faExternalLinkAlt,
    type: 'fa'
  },
  eye: {
    asset: faEye,
    type: 'fa'
  },
  eyeSlash: {
    asset: faEyeSlash,
    type: 'fa'
  },
  fileAlt: {
    asset: faFileAlt,
    type: 'fa'
  },
  fileImage: {
    asset: faFileImage,
    type: 'fa'
  },
  fileImageRegular: {
    asset: fafileImageRegular,
    type: 'fa'
  },
  fileImport: {
    asset: faFileImport,
    type: 'fa'
  },
  folderOpen: {
    asset: faFolderOpen,
    type: 'fa'
  },
  frown: {
    asset: faFrown,
    type: 'fa'
  },
  gcash: {
    asset: IconGcash,
    type: 'assets'
  },
  google: {
    asset: faGoogle,
    type: 'fa'
  },
  googlepay: {
    asset: IconGooglePay,
    type: 'assets'
  },
  grabpay: {
    asset: IconGrabpay,
    type: 'assets'
  },
  hamburgerMenu: {
    asset: faBars,
    type: 'fa'
  },
  infoCircle: {
    asset: faInfoCircle,
    type: 'fa'
  },
  lock: {
    asset: faLock,
    type: 'fa'
  },
  paperclip: {
    asset: faPaperclip,
    type: 'fa'
  },
  mastercard: {
    asset: IconMastercard,
    type: 'assets'
  },
  mobile: {
    asset: faMobile,
    type: 'fa'
  },
  mobileAlt: {
    asset: faMobileAlt,
    type: 'fa'
  },
  moneyCheck: {
    asset: faMoneyCheck,
    type: 'fa'
  },
  otc: {
    asset: IconOtc,
    type: 'assets'
  },
  paymaya: {
    asset: IconPaymaya,
    type: 'assets'
  },
  phone: {
    asset: faPhone,
    type: 'fa'
  },
  plus: {
    asset: faPlus,
    type: 'fa'
  },
  redoAlt: {
    asset: faRedoAlt,
    type: 'fa'
  },
  search: {
    asset: faSearch,
    type: 'fa'
  },
  shopeepay: {
    asset: IconShopeePay,
    type: 'assets'
  },
  smile: {
    asset: faSmile,
    type: 'fa'
  },
  signOut: {
    asset: faSignOutAlt,
    type: 'fa'
  },
  spinner: {
    asset: faSpinner,
    type: 'fa'
  },
  tasks: {
    asset: faTasks,
    type: 'fa'
  },
  times: {
    asset: faTimes,
    type: 'fa'
  },
  timesCircle: {
    asset: faTimesCircle,
    type: 'fa'
  },
  trash: {
    asset: faTrash,
    type: 'fa'
  },
  trashAlt: {
    asset: faTrashAlt,
    type: 'fa'
  },
  trashAltRegular: {
    asset: faTrashAltRegular,
    type: 'fa'
  },
  unlock: {
    asset: faUnlock,
    type: 'fa'
  },
  upload: {
    asset: faUpload,
    type: 'fa'
  },
  user: {
    asset: faUser,
    type: 'fa'
  },
  userFriends: {
    asset: faUserFriends,
    type: 'fa'
  },
  userTie: {
    asset: faUserTie,
    type: 'fa'
  },
  visa: {
    asset: IconVisa,
    type: 'assets'
  },
  visaMastercard: {
    asset: IconCreditCards,
    type: 'assets'
  },
  wallet: {
    asset: faWallet,
    type: 'fa'
  },
  warn: {
    asset: faExclamationCircle,
    type: 'fa'
  },
  warnTriangle: {
    asset: faExclamationTriangle,
    type: 'fa'
  }
};
